import React, { useContext, useState, useEffect, Fragment } from 'react';

import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  Alert,
  TextField,
} from '@mui/material';

import * as customGql from 'graphql/custom/functions';

import OperatorContext from './context';
import * as actions from './actions';

function plain(str) {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

function compareCity(a, b) {
  return plain(a.name).localeCompare(plain(b.name));
}

const states = [
  'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA',
  'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO',
];

const AddHeadquarter = (props) => {
  const { state, dispatch } = useContext(OperatorContext);

  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [uf, setUf] = useState('AL');
  const [loadingCities, setLoadingCities] = useState(false);

  const [errorAlert, setErrorAlert] = useState(null);

  useEffect(() => {
    listCities();

    return function cleanup() {};
  }, [uf]);

  const listCities = async function () {
    try {
      setLoadingCities(true);
      setCities([]);

      const result = await customGql.getCities(uf);
      if (result.errors) {
        console.log(result.errors);
        throw new Error(result.errors[0].message);
      }

      setCities([...result.items].sort(compareCity));
    } catch (error) {
      console.log(error);
      setErrorAlert(error.message || String(error));
    } finally {
      setLoadingCities(false);
    }
  };

  function handleChangeState(aEvent) {
    setUf(aEvent.target.value);
    setSelectedCity(null);
  }

  function close() {
    setSelectedCity(null);
    dispatch({ type: actions.MODAL_HEADQUARTER, payload: false });
  }

  function onOK() {
    let op = Object.assign({}, state.operator);
    op.headquarterId = selectedCity.id;
    dispatch({ type: actions.SET_OPERATOR, payload: op });
    close();
  }

  return (
    <Fragment>
      {/* Mensagens de erro  */}
      <Snackbar open={Boolean(errorAlert)} autoHideDuration={2500} onClose={() => setErrorAlert(null)}>
        <Alert onClose={() => setErrorAlert(null)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {errorAlert}
        </Alert>
      </Snackbar>
      <Dialog open={Boolean(state.modalHeadquarter)} onClose={close} maxWidth="sm" fullWidth>
        <DialogTitle>Sede do operador</DialogTitle>

        <DialogContent>
          <Box display="flex" columnGap={2} alignItems="flex-end" pt={1}>
            <FormControl variant="standard" sx={{ width: 90, flexShrink: 0 }}>
              <InputLabel>Estado</InputLabel>
              <Select name="region_state" value={uf} onChange={handleChangeState}>
                {states.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Autocomplete
              sx={{ flex: 1 }}
              options={cities}
              value={selectedCity}
              onChange={(e, value) => setSelectedCity(value)}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              loading={loadingCities}
              loadingText="Carregando cidades..."
              noOptionsText="Nenhuma cidade encontrada"
              autoHighlight
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cidade"
                  variant="standard"
                  placeholder="Digite para buscar"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <Fragment>
                        {loadingCities && <CircularProgress color="inherit" size={18} />}
                        {params.InputProps.endAdornment}
                      </Fragment>
                    ),
                  }}
                />
              )}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={close} color="secondary">
            Cancelar
          </Button>
          <Button onClick={onOK} variant="contained" color="primary" disabled={selectedCity === null}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default AddHeadquarter;
